// Saved Routes API client. Mirrors modules/leads/leadService.js conventions.
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;
const getHeaders = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });

export const getRoutes = async () => {
  const res = await axios.get(`${API_URL}/routes`, getHeaders());
  return res.data.routes || [];
};

export const getRoute = async (id) => {
  const res = await axios.get(`${API_URL}/routes/${id}`, getHeaders());
  return res.data.route;
};

export const createRoute = async (body) => {
  const res = await axios.post(`${API_URL}/routes`, body, getHeaders());
  return res.data.route;
};

export const updateRoute = async (id, body) => {
  const res = await axios.put(`${API_URL}/routes/${id}`, body, getHeaders());
  return res.data.route;
};

export const deleteRoute = async (id) => {
  const res = await axios.delete(`${API_URL}/routes/${id}`, getHeaders());
  return res.data;
};

// stops: [{ lead_id, lead_address_id }] — lead_address_id null/omitted means the
// lead's primary address. A lead may appear several times with different
// addresses, so the same customer can be visited at two sites on one route.
export const addStopsToRoute = async (id, stops) => {
  const res = await axios.post(`${API_URL}/routes/${id}/leads`, { stops }, getHeaders());
  return res.data;
};

// Convenience wrapper for the common "just add these leads at their primary
// address" case.
export const addLeadsToRoute = async (id, leadIds) =>
  addStopsToRoute(id, leadIds.map(lead_id => ({ lead_id, lead_address_id: null })));

// Removes ONE stop, keyed by RouteLeads.id — a lead may hold several stops on
// the same route and the others must survive.
export const removeStopFromRoute = async (id, stopId) => {
  const res = await axios.delete(`${API_URL}/routes/${id}/stops/${stopId}`, getHeaders());
  return res.data;
};

// orderedStopIds: array of stop ids (RouteLeads.id) in the optimized visiting
// order. Lead ids can't be used here — they no longer identify a stop uniquely.
export const saveRouteOrder = async (id, orderedStopIds) => {
  const res = await axios.put(`${API_URL}/routes/${id}/order`, { ordered_stop_ids: orderedStopIds }, getHeaders());
  return res.data;
};

// Each route also carries `address_ids`: which of this lead's addresses are
// already stops on it (null = the primary address). The add-to-route picker
// needs that granularity, not just "is this lead on the route".
export const getRoutesByLead = async (leadId) => {
  const res = await axios.get(`${API_URL}/routes/by-lead/${leadId}`, getHeaders());
  return res.data.routes || [];
};
